<template>
  <div class="interiorzone">
    <h2 class="subheading">添加合作机构</h2>
    <div class="contentbox">
      <div class="content-order-listbox">
        <ul class="content-organ-add">
          <li class="hd">
            <div>公司名称</div>
            <div>统一社会信用代码</div>
            <div>详细地址</div>
            <div>法人姓名</div>
            <div>法人身份证</div>
            <div>录入与操作</div>
          </li>
          <li>
            <div><input type="text" v-model="companyName" ref="inputa"></div>
            <div><input type="text" v-model="organizationCode" ref="inputb"></div>
            <div><input type="text" v-model="companyAddr" ref="inputc"></div>
            <div><input type="text" v-model="legalName" ref="inputd"></div>
            <div><input type="text" v-model="legalCardCode" ref="inpute"></div>
            <div class="infoperation"><div class="ysbox"><i @click="setevocation(1)">录入授权代理人</i><i @click="setevocation(2)">录入收款信息</i><button class="addok"  @click="setevocation(3)">确认创建</button></div></div>
          </li>
        </ul>
      </div>
    </div>
   <div class="infochange" v-if="isconfirm">
    <div class="remind">
      <h2>确认创建此机构账户？</h2>
      <div class="btn-confirm">
        <button class="addok" @click="companyadd()">确认</button>
        <button class="addok" @click="closeevocation(3)">取消</button>
      </div>
    </div>
   </div>
    <div class="infochange" v-if="evocationagent">
      <div class="infobox">
        <h2>合作机构授权代理人信息录入</h2>
        <div class="personal ">
          <label>姓名:</label><input type="text" v-model="agentName" ref="inputf" >
        </div>
        <div class="personal ">
          <label>身份证号:</label><input type="text" v-model="agentCardCode" ref="inputg" >
        </div>
        <div class="personal ">
          <label>手机号码:</label><input type="text" v-model="agentPhone" ref="inputh" >
        </div>
        <div class="personal ">
          <label>联系邮箱:</label><input type="text" v-model="agentEmail" ref="inputi" >
        </div>
        <div class="personal">
          <label>授权书:</label><p class="cursor">
            <a href="javascript:void(0);">上传代理授权书<input type="file" class="uplicense imga" id="id"  ref="inputer"  @change="addImga($event,1)"   accept="image/png,image/jpeg,image/jpg"/></a><i v-if="imgup1&&imgupstyle1!=''"  class="loadstyle" :class="imgupstyle1"  :alt='imgstyletxt1' :title="imgstyletxt1"></i></p>
        </div>
        <div class="btn-confirm">
        <button class="addok" @click="closeevocation(1)">确认</button>
        <button class="addno" @click="closeevocation(1)">取消</button>
      </div>
      </div>
    </div>
    <div class="infochange"  v-if="evocationbank">
      <div class="infobox">
        <h2>合作机构收款信息录入</h2>
        <div class="personal ">
          <label>账户名称:</label> <span class="connectedness">{{accountName}}</span>
        </div>
        <div class="personal ">
          <label>账户号码:</label><input type="text" v-model="bankNumber" ref="inputk" >
        </div>
        <div class="personal ">
          <label>开户银行:</label><input type="text" v-model="bankBranchName" ref="inputl" >
        </div>
        <div class="personal ">
          <label>开户行号:</label><input type="text" v-model="bankCode" ref="inputm" >
        </div>
        <div class="personal">
          <label>收款码:</label><p class="cursor">
            <a href="javascript:void(0);">上传收款二维码<input type="file" class="uplicense imga" id="id"  ref="inputer"  @change="addImga($event,2)"   accept="image/png,image/jpeg,image/jpg"/></a><i v-if="imgup2&&imgupstyle2!=''"  class="loadstyle" :class="imgupstyle2"  :alt='imgstyletxt2' :title="imgstyletxt2"></i></p>
        </div>
        <div class="btn-confirm">
        <button class="addok" @click="closeevocation(2)">确认</button>
        <button class="addno" @click="closeevocation(2)">取消</button>
      </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      companyName:'',
      organizationCode:'',
      companyAddr:'',
      legalName:'',
      legalCardCode:'',
      agentName:'',
      agentCardCode:'',
      agentPhone:'',
      agentEmail:'',
      letterAuthorization:'',
      bankNumber:'',
      bankBranchName:'',
      bankCode:'',
      qrCode:'',
      accountName:'',
      isconfirm:false,
      evocationbank:false,
      evocationagent:false,
      imgup1:false,
      imgup2:false,
      imgupstyle1:"",
      imgstyletxt1:"",
      imgupstyle2:"",
      imgstyletxt2:""
    }
  },
  methods: {
    setevocation(val){
      if(val==1){
        this.evocationagent=true
        this.evocationbank=false
        this.isconfirm=false
      }
      else if(val==2){
        if(this.companyName==''){
          swal({
            text: '请填写企业名称并完成前置表单',
            timer: 2000,
            buttons: false
          })
          this.$refs.inputa.focus()
        }
        else{
          this.evocationbank=true
          this.evocationagent=false
          this.isconfirm=false
          this.accountName=this.companyName
        }
      }
      else if(val==3){
        this.isconfirm=true
        this.evocationagent=false
        this.evocationbank=false
      }
      else{}
    },
    closeevocation(val){
      this.isconfirm=false
      this.evocationagent=false
      this.evocationbank=false
    },
    addImga(e,val){
      let file = e.target.files[0]
      let mbyte=Number(file.size)/1024/1024
      if(mbyte>2){
        swal({
          text: '图片过大，请使用小于2MB的文件！~',
          timer: 2000,
          buttons: false
        })
      }
      else{
        if(val==1){
        let param = new FormData()
        param.append('file', file, file.name)
        this.imgup1=true,
        this.imgupstyle1='imgup'
        this.upimg(param).then(resolve=>{
          if(resolve!=""){
            this.letterAuthorization=this.versatile.imgUrl+resolve
            this.imgstyletxt1='授权书上传成功',
            this.imgup1=true,
            this.imgupstyle1='imgok'
            }
          else{
            this.imgstyletxt1='授权书上传失败',
            this.imgup1=true,
            this.imgupstyle1='imgfail'
          }
          })
      }
      else if(val==2){
        let param = new FormData()
        param.append('file', file, file.name)
        this.imgup2=true,
        this.imgupstyle2='imgup'
        this.upimg(param).then(resolve=>{
          if(resolve!=""){
            this.qrCode=this.versatile.imgUrl+resolve
            this.imgstyletxt2='二维码上传成功',
            this.imgup2=true,
            this.imgupstyle2='imgok'
            }
          else{
            this.imgstyletxt2='二维码上传失败',
            this.imgup2=true,
            this.imgupstyle2='imgfail'
          }
          })
      }
    }
   },
   upimg(val){
      return this.ajax.post('/upload/fastdfsUpload',val)
        .then(resolve => {
          if(resolve.data.status=="0000"){
            return Promise.resolve(resolve.data.data) ;
          }
          else{
            swal({
              text: resolve.data.message,
              timer: 2000,
              buttons: false
            })
            return Promise.resolve("")
          }
        }
      )
    },
    companyadd(){
      if(this.companyName==''){
        swal({
          text: '请填写企业名称！',
          timer: 2000,
          buttons: false
        })
        this.$refs.inputa.focus()
        this.isconfirm=false
        this.evocationagent=false
        this.evocationbank=false
      }
      else if(this.organizationCode==''){
        swal({
          text: '请填写统一社会信用代码！',
          timer: 2000,
          buttons: false
        })
        this.$refs.inputb.focus()
        this.isconfirm=false
        this.evocationagent=false
        this.evocationbank=false
      }
      else if(this.companyAddr==''){
        swal({
          text: '请填写企业地址！',
          timer: 2000,
          buttons: false
        })
        this.$refs.inputc.focus()
        this.isconfirm=false
        this.evocationagent=false
        this.evocationbank=false
      }
      else if(this.legalName==''){
        swal({
          text: '请填写法人姓名',
          timer: 2000,
          buttons: false
        })
        this.$refs.inputd.focus()
        this.isconfirm=false
        this.evocationagent=false
        this.evocationbank=false
      }
      else if(this.legalCardCode==''){
        swal({
          text: '请填写法人身份证号码',
          timer: 2000,
          buttons: false
        })
        this.$refs.inpute.focus()
        this.isconfirm=false
        this.evocationagent=false
        this.evocationbank=false
      }
      else if(this.agentName!=''&&this.letterAuthorization==''){
        swal({
          text: '请确认代理人信息是否完整并已上传代理授权书',
          timer: 2000,
          buttons: false
        })
        this.isconfirm=false
        this.evocationagent=true
        this.evocationbank=false
      }
      else if(this.accountName==''){
        swal({
          text: '请录入收款信息并填写收款银行账户名',
          timer: 2000,
          buttons: false
        })
        this.isconfirm=false
        this.evocationagent=false
        this.evocationbank=true
      }
      else if(this.bankNumber==''){
        swal({
          text: '请录入收款信息并填写收款银行账户号码',
          timer: 2000,
          buttons: false
        })
        this.isconfirm=false
        this.evocationagent=false
        this.evocationbank=true
      }
      else if(this.bankBranchName==''){
        swal({
          text: '请录入收款信息并填写收款银行开户行',
          timer: 2000,
          buttons: false
        })
        this.isconfirm=false
        this.evocationagent=false
        this.evocationbank=true
      }
      else if(this.bankCode==''){
        swal({
          text: '请录入收款信息并填写收款银行行号',
          timer: 2000,
          buttons: false
        })
        this.isconfirm=false
        this.evocationagent=false
        this.evocationbank=true
      }
      else{
        this.ajax.post('/auth/addBase',
          {
            bizContent:{
              companyName:this.accountName,
              organizationCode:this.organizationCode,
              companyAddr: this.companyAddr,
              legalName:this.legalName,
              legalCardCode:this.legalCardCode,
              agentName:this.agentName,
              agentCardCode:this.agentCardCode,
              agentPhone:this.agentPhone,
              agentEmail:this.agentEmail,
              letterAuthorization:this.letterAuthorization,
              bankNumber:this.bankNumber,
              bankBranchName:this.bankBranchName,
              bankCode:this.bankCode,
              qrCode:this.qrCode,
              accountName:this.accountName
            }
          }
        )
        .then(
          result=>{
            if(result.data.status=='0000'){
              swal({
                text: '添加成功',
                timer: 1000,
                buttons: false
              })
              this.$router.push({name:'OrganList'})
            }
            else{
              swal({
                text: result.data.message,
                timer: 2000,
                buttons: false
              })
            }
          }
        )
      }
    }
  }
}
</script>

<style>
.infochange{
  width:100%;
  height:100%;
  position: fixed;
  top:0;
  left:0;
  bottom:0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9999
}
.infobox{
  position: absolute;
  width:520px;
  padding: 20px 20px 30px 20px;
  background: #fff;
  left:50%;
  margin-left:-280px;
  top: 154px;
  margin-bottom: 60px;
  background-color: #fff;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
  border: 1px solid #dce1e6;
}
.infobox h2{
  height:38px;
  line-height:38px;
  text-indent: 6px;
  margin-bottom: 32px;
  color:#222222;
  font-size: 16px;
  text-align: center;
  font-weight: 600
}
.infobox input{
  border: 1px solid rgba(204, 204, 204, 0.4);
  width:60%;
  margin-left:15px;
  padding-left:10px;
  border-radius: 2px
}
.infobox .personal,.infobox .personal input{
  height:32px;
  line-height:32px;
}
.infobox .personal{
  display: table;
  margin-left:auto;
  margin-right: auto;
  width:60%;
  margin-bottom:26px;
}
.infobox .personal p > a{
  width: 120px;
  overflow: hidden;
  position: relative;
}
.infoclose{
  width:26px;
  height:26px;
  top: 0;
  position: absolute;
  right:-32px;
  cursor: pointer;
  opacity: 0.5;
}
.infoclose:before {
  font-size: 22px;
  color: #fff;
  content: "\e7d1";
}
.infoclose:hover{
  opacity: 1;
}
.infosubtn{
  width:30%;
  height:38px;
  line-height:38px;
  background: #3D8FE2;
  color: #fff;
  margin:0 auto;
  text-align: center;
  border-radius: 2px;
  cursor: pointer;
  margin-top:38px;
}
.personal{
  width: 100%;
  clear: both;
  height:26px;
  line-height:26px;
  margin-bottom:15px;
  font-size: 14px;
  position: relative;
}
.personal label{
  width:25.5%;
  float: left;
  text-align: right;
}
.personal p{
  width:50%;
  float: left;
  margin-left:3%;
  text-align:left;
}
.personal p > a{
  float: right;
  width:80px;
  color:#1381EF;
  text-decoration: underline;
}
.infobox input.uplicense{
  width: 224px;
  height: 104px;
  position: absolute;
  top: 0;
  left: 0;
  line-height: 99999;
  opacity: 0;
  cursor: pointer;
}
.imgup1{
  background: url('../../assets/uping.png') center  no-repeat;
  animation:rotateIn .6s linear infinite;
  -webkit-animation:rotateIn .6s linear infinite;
  -moz-animation:rotateIn .6s linear infinite;
}
.imgok{
  background: url('../../assets/upload.png') center 0 no-repeat;
}
.imgfail{
  background: url('../../assets/upingerro.png') center  no-repeat;
}
.infobox .addok,.infobox .addno{
  width:100px;
  height:40px;
}
.addno{
  background: #fff;
  color: #3D8FE2;
  border-radius: 4px;
  margin-top: 10px;
  text-align: center;
  cursor: pointer;
  box-shadow: 0px 0px 12px rgba(61, 143, 226, .6);
  width:96px;
  height:36px;
  border: 1px solid #3d8fe2;
  margin-left:30px;
}
.infobox .btn-confirm button:nth-child(2) {margin-left:30px;}
.loadstyle{
  position: absolute;
  right: 50px;
  top:6px;
  width:20px;
  height:20px;
}
</style>


// WEBPACK FOOTER //
// src/page/partner/organadd.vue